module.exports = __webpack_public_path__ + "static/media/tlyfheader.4f966fa1.png";